import { render, staticRenderFns } from "./riskanalysis.vue?vue&type=template&id=6ed8638e&"
import script from "./riskanalysis.vue?vue&type=script&lang=js&"
export * from "./riskanalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports